import React, { useRef} from 'react';
import './Contact.css';
import emailjs from '@emailjs/browser';
import { useState } from 'react';

const Contact = () => {



    const form = useRef();

    const [done, setDone] = useState(false);

    const sendEmail = (e) => {
      e.preventDefault();
  
      emailjs.sendForm('service_zed0xkq', 'template_jiy4k2j', form.current, 'U-AiMMWUQqJlhBmxM')
        .then((result) => {
            console.log(result.text);
            setDone(true);
        }, (error) => {
            console.log(error.text);
        });
    };




  return (
    <div className='contact-form' id='Contact'>
        <div className='w-left'>
            <div className='awesome1'>
                <span>Get in touch</span>
                <br/>
                <span>Contact me</span>
                <div 
                className='blur s-blurl'
                style={{background: '#ABF1FF94'}}>
                </div>
            </div>
        </div>

        <div className='c-right'>
            <form ref={form} onSubmit={sendEmail}>
                <input type='text' name='from_name' className='user' placeholder='Name' />
                <input type='email' name='from_email' className='user' placeholder='Email' />
                <textarea name='message' className='user' placeholder='Message'/>
                <input type='submit' value='Send' className='button' />   
                <span>{done && "Thankyou for contacting me"}</span>
                <div 
                className='blur c-blurl'
                style={{background: 'var(--purple)'}}
                ></div>            
            </form>
        </div>
    </div>
  );
};

export default Contact